export default __webpack_public_path__ + "static/media/clubBg1.db9a3680.png";